"use client";

import React from "react";
import { Quote } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  quote: "EduStrategy Group helped us develop a lifelong learning ecosystem that truly empowers our faculty and staff. The transformation was not just structural but cultural.",
  author: "\n",
  title: "University President",
  institution: "State University of Innovation"
}, {
  quote: "Their pragmatic, collaborative approach transformed our organizational capacity in less than a year. We now own our growth strategy completely.",
  author: "\n",
  title: "Dean of Continuing Education",
  institution: "Metro City College"
}, {
  quote: "Unlike other consultants who drop a deck and leave, ESG embedded themselves with our team. We built the capability to sustain this growth long after they left.",
  author: "\n",
  title: "Provost",
  institution: "Global Tech Institute"
}, {
  quote: "The focus on mission-aligned growth was critical for us. We didn't just increase revenue; we deepened our impact on the communities we serve.",
  author: "Michael Chen",
  title: "VP of Strategy",
  institution: "Future Learning Foundation"
}];
export default function VoicesOfLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="voices-of-leadership" ref={ref} className={cn("dark bg-background text-foreground py-16 relative overflow-hidden", isVisible ? "opacity-100" : "opacity-0 transition-opacity duration-1000")}>
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        {}
        <div className="mb-16 md:mb-24 max-w-3xl">
          <h2 className="text-4xl md:text-5xl font-serif font-bold tracking-tight mb-6 text-foreground">
            Voices of Leadership
          </h2>
          <div className="w-20 h-1 bg-secondary mb-6" />
          <p className="text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl">
            Hear from the visionary leaders who have partnered with us to build
            sustainable, internal capacity for lifelong learning.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((item, i) => <div key={i} data-index={i} className={cn("transition-all duration-700 delay-[var(--delay)]", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")} style={{
          "--delay": `${i * 150}ms`
        } as React.CSSProperties}>
              <Card className={cn("h-full border-border relative overflow-hidden group hover:shadow-lg transition-shadow duration-300", i % 2 !== 0 ? "bg-[hsl(180_50%_33%)]/10" : "bg-card")}>
                <CardContent className="p-8 md:p-10 flex flex-col h-full relative z-10">
                  {}
                  <div className="absolute top-4 left-6 text-[10rem] leading-none font-serif text-primary/10 select-none pointer-events-none z-0" aria-hidden="true">
                    &ldquo;
                  </div>

                  {}
                  <blockquote className="relative z-10 mb-8">
                    <p className="text-xl md:text-2xl font-serif leading-relaxed text-foreground/90 italic">
                      {item.quote}
                    </p>
                  </blockquote>

                  {}
                  <div className="mt-auto relative z-10 flex items-center gap-4">
                    <div className="h-12 w-1 bg-secondary rounded-full" />
                    <div>
                      
                      <span className="block text-sm font-medium text-muted-foreground mt-1">
                        {item.title}
                      </span>
                      <span className="block text-xs uppercase tracking-wider text-primary/80 mt-1 font-semibold">
                        {item.institution}
                      </span>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>

        {}
        <div className="mt-16 text-center">
          <Button asChild size="lg" className="text-base px-8 py-6">
            <Link to="https://edustrategygroup.com/schedule-your-strategy-session/">Start a Conversation</Link>
          </Button>
        </div>
      </div>
    </section>;
}